import React, { useEffect, useState } from 'react';
import { 
    Flex,
    Text,
    Button,
    IconButton,
    Image,
    Tooltip,
    Input,
    useDisclosure,
    Alert,
    AlertIcon,
    Grid,
    GridItem,
} from '@chakra-ui/react';
import { MinusIcon } from '@chakra-ui/icons';
import { FaPlus } from "react-icons/fa";
import icon2 from '../../assets/icons/package.svg';
import ModalPrintImage from '../ModalPrintImage';
import { 
    selectTotalAmountRetail
} from '../../hooks/slices/counterSlice';
import { useSelector } from 'react-redux';

import { formatterValue, capitalizeFirstLetter } from '../../resource/validate';

const Description = ({ previewImage, setImg, images, data, colors, colorsProduct, printingType, handleSubmitToCart, setSelectedColor, selectedColor, itemSelected, setItemSelected }) => {
    const totalAmount = useSelector(selectTotalAmountRetail);
    const { isOpen, onOpen, onClose } = useDisclosure();
    //const [selectedColor, setSelectedColor] = useState(null);
    //const [itemSelected, setItemSelected] = useState(data.items[0]);
    const [price, setPrice] = useState(0);
    const [amount, setAmount] = useState(0);
    const [values, setValues] = useState({
        num: 0
    });

    useEffect(() => {
        if (data) {
            if(totalAmount >= 15001){
                let unitRetailPrice = data.items[0]?.wholesale_price ? data.items[0]?.wholesale_price : (data.items[0]?.retail_price ? data.items[0]?.retail_price : 0);
                setValues({
                    ...values,
                    unitPrice: parseFloat(unitRetailPrice).toFixed(2),
                });
            }else{
                let unitRetailPrice = data.items[0]?.retail_price ? data.items[0]?.retail_price : (data.items[0]?.wholesale_price ? data.items[0]?.wholesale_price : 0);
                setValues({
                    ...values,
                    unitPrice: parseFloat(unitRetailPrice).toFixed(2),
                });
            }
        }
    }, []);

    useEffect(()=>{
        calculateTotal()
    },[amount, printingType]) 

    const calculateTotal = () => {
        let printing_unitary = 0;
        if(printingType !== 'none'){
            switch(printingType){
                case 'laser': {
                    if (values.amount <= 99) {
                      printing_unitary = 25;
                    } else {
                      printing_unitary = 15;
                    }
                    break;
                }
                case 'serigrafia': {
                    if (values.amount <= 99) {
                      printing_unitary = 8;
                    } else if (values.amount > 99 && values.amount <= 149) {
                      printing_unitary = 5;
                    } else {
                      printing_unitary = 3;
                    }
                    break;
                }
                default: {
                    printing_unitary = 0;
                    break;
                }
            }

        }
        const printing_total = printing_unitary * values.amount;
        const totalRetail = (data.items[0]?.retail_price * values.amount) + printing_total;
        let total = values.unitPrice * values.amount;
        total += printing_total;
        let unitPrice = data.items[0]?.retail_price ? data.items[0]?.retail_price : (data.items[0]?.wholesale_price ? data.items[0]?.wholesale_price : 0);
        if(total >= 15001 || totalAmount >= 15001 || totalRetail >= 15001 || (totalRetail + totalAmount) >= 15001){
            unitPrice = data.items[0]?.wholesale_price;
        }else{
            unitPrice = data.items[0]?.retail_price;
        }
        setValues({
            ...values,
            unitPrice: parseFloat(unitPrice).toFixed(2),
        })
    }

    const changeNumProducts = (nums) => {
        setValues({
            ...values,
            num: nums < 0 ? 0 : nums
        }) 
        setAmount(nums)
    }

    const handleChange = (e) => {
        setValues({
            ...values,
            [e.target.name]: parseInt(e.target.value)
        })
    }

    useEffect(() => {
        const prices = []
        data.items.map((item)=>{
            prices.push(item.wholesale_price)
        })
        setPrice(Math.min(...prices));
    },[colors])

    const handleChangeSelected = (color, sku) => {
        setSelectedColor(color);
        const item = data.items.filter((item)=>item.sku === sku)[0]
        setItemSelected(item)
        setPrice(item.wholesale_price);
    }

    useEffect(() => {
        if(selectedColor) {
            const filterProductColors = data?.items.filter(item => item.color === selectedColor.toUpperCase());
            const imgUrl = filterProductColors[0].images?.images_item[0];
            setImg(imgUrl)
        }
    }, [selectedColor]);

    const validateData = () => {
        if (itemSelected?.stock !== "0") {
            if(printingType === 'none'){
                if (selectedColor && values.num !== 0 && values.num <= itemSelected?.stock) {
                    return false;
                }else{
                    return true;
                }
            }else{
                if (selectedColor && values.num >= 50 && values.num <= itemSelected?.stock) {
                    return false;
                }else{
                    return true;
                }
            }
            
        }
        return true;
    }

    const handleSubmit = () => {
        if (validateData() === false) {
            handleSubmitToCart(values.num, values.unitPrice);
        }
    }

    return ( 
        <Flex flexDirection={"column"}>
            <Flex>
                <Text fontSize={"26px"} fontWeight={600} color={"accent.500"}>{data.name.toUpperCase()}</Text>
            </Flex>
            <Flex mt={10} fontSize={"14px"} fontWeight={400} color={"#424242"}>
                <Text mr={10}><Text as={"b"}>SKU:</Text>{" "}{data.sku}</Text>
                <Text><Text as={"b"}>Categoría:</Text>{" "}{data.category.toUpperCase()}</Text>
            </Flex>
            <Flex fontSize={"14px"} fontWeight={400} color={"#424242"} alignItems={"center"}>
                <Text as={"b"}>Colores:</Text>
                <Grid
                    w="100%"
                    pl={2}
                    templateColumns={{base: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)", xl: "repeat(7, 1fr)"}}
                >
                    {colorsProduct.map((item, index) => (
                        <GridItem key={`color-${index}`} > 
                            <Tooltip hasArrow label={item.color} bg='gray.300' color='black'>
                                <Text
                                    marginRight={"1px"}
                                    cursor="pointer"
                                    fontSize={"50px"}
                                    color={item.color === "BLANCO" ? "#F4F4F4" :  item.hex}
                                    onClick={() => {
                                        handleChangeSelected(item.color, item.sku)
                                    }}
                                >
                                    &#9679;
                                </Text>
                            </Tooltip>
                        </GridItem>
                    ))}
                </Grid>
            </Flex>
            <Flex mt={5} flexDirection={"column"} gap={2}>
                {selectedColor ?
                    <Flex>
                        <Text as={"b"}>Color seleccionado:</Text>
                        <Text ml={2}>{capitalizeFirstLetter(selectedColor)}</Text>
                    </Flex>
                    : null
                }
                <Flex mt={2} mb={1}>
                    <Text fontSize={"12px"} fontWeight={400} color={"#383838"}>Desde</Text>
                </Flex>
                <Flex alignItems={"center"}>
                    <Text mr={5} fontSize={"36px"} fontWeight={700} color={"#383838"}>{formatterValue(price)} <Text fontSize={"12px"} fontWeight={500} color={"#383838"} display={"inline-block"}>+ IVA</Text></Text>
                </Flex>
                {printingType ?
                    <Flex mt={2}>
                        <Text as={"b"} fontSize={'sm'}>Tipo de impresión seleccionada:</Text>
                        <Text ml={2} fontSize={'sm'}>{capitalizeFirstLetter(printingType === 'laser' ? 'Láser' : (printingType === 'serigrafia' ? 'Serigrafía' : 'Sin impresión'))}</Text>
                    </Flex>
                    : null
                }
            </Flex>
            <Flex mt={10}>
                <Flex>
                    <Button w={"176px"} fontSize={"14px"} fontWeight={500}
                        _hover={{
                            bg: "#063D5F"
                        }}
                        //onClick={() => addProductShoppingCart()}
                        onClick={() => handleSubmit()}
                        isDisabled={validateData()}>Agregar al carrito
                    </Button>
                </Flex>
                <Flex ml={10} alignItems={"center"}>
                    <IconButton
                        w={"37px"} h={"37px"}
                        bg={"#D0D0D2"}
                        onClick={() => changeNumProducts(values.num - 1)}
                        boxShadow={"rgb(221, 221, 221) 0px 4px 8px 0px"}
                        color={"#383838"}
                        fontSize={"16px"}
                        icon={<MinusIcon />}/>
                    <Input 
                        name='num' type='number' m={"0px 1rem"}
                        onChange={handleChange} value={values.num} fontWeight={500} fontSize={"16px"} 
                        width={"80px"} height={"40px"} 
                        max={itemSelected?.stock}
                        />
                    <IconButton
                        w={"37px"} h={"37px"}
                        bg='#31508C'
                        onClick={() => changeNumProducts(values.num + 1)}
                        boxShadow={"rgb(221, 221, 221) 0px 4px 8px 0px"}
                        color={"#FFF"}
                        fontSize={"16px"}
                        _hover={{
                            bg: '#24437E'
                        }}
                        icon={<FaPlus />}/>
                </Flex>
            </Flex>
            <Alert status='info' mt={4} display={selectedColor ? "none" : "flex"}>
                <AlertIcon />
                Selecciona un color para agregar al carrito de compra
            </Alert>
            <Flex mt={5} h={"66px"} border={"1px solid"} borderTopColor={"#CCCCCC"} borderBottomColor={"#CCCCCC"} borderLeftColor={"transparent"} borderRightColor={"transparent"}>
                <Flex  alignItems={"center"}>
                    <Image src={icon2} width={"32px"} height={"32px"} alt='icon'/>
                    <Text ml={2}>{itemSelected?.stock} en stock</Text>
                </Flex>
            </Flex>
            <Flex mt={5}>
                <Button onClick={onOpen} type='button' w={"430px"} fontSize={"14px"} fontWeight={500} color={"accent.500"} borderColor={"accent.500"} variant='outline'>Ver previsualización de impresión</Button>
            </Flex>
            {isOpen ?
                    <ModalPrintImage
                        isOpen={isOpen}
                        onClose={onClose}
                        category={data.name.toUpperCase()}
                        product={previewImage} />
                : null
            }
        </Flex>
    );
}
 
export default Description;